import React, { Component } from 'react'
import { Upload, message, Button, Icon,Modal } from 'antd';
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

export default class SelectFile extends Component {


  constructor(props) {
    super(props);
    const value = props.value || [];
    this.state = {
      fileList: this.convertValueToFileList(value),
    };
  }


  convertValueToFileList = (value) => {
    return value.map((item, i) => {
      console.log(item,i)
      return {
        uid: -i,
        name: item.name,
        status: 'done',
        url: item.url,
      }
    })
  }

 convertFileListToValue = (fileList) => {
    return fileList.map((item, i) => {
      return {
        name: item.name,
        url: item.url,
      }
    })
  }

    // 处理删除逻辑
    onChange = (info) => {
      console.log(info,'info')
        let fileList = this.state.fileList;
        if (info.file.status === 'removed') {
          message.error(`${info.file.name} 删除成功`);
          fileList = fileList.filter(item => {
            return item.uid != info.file.uid
          })
          console.log(fileList)
          this.triggerChange(fileList);
        }
    }

  beforeUpload = (file) => {
    console.log('file' , file);
    // const{ onChange } = this.props;
    // if (onChange) {
    //     onChange(this.convertFileListToValue([...this.state.fileList, file]));
    //   }
  }


  render() {
     const { crop, croppedImageUrl, src , visible } = this.state;
    const{ onChange } = this.props;
    const props = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        console.log('file' ,file)
        if(onChange) {
          onChange(file);
        }
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList: this.state.fileList,
    };

    return (<Upload {...props}>
      <Button>
        <Icon type="upload" /> 选择文件
          </Button>
            <Modal>
                {src && (
                    <ReactCrop
                        src={src}
                        crop={crop}
                        ruleOfThirds
                    />
                    )}
                     {croppedImageUrl && (
                    <img alt="Crop" style={{ maxWidth: "100%" }} src={croppedImageUrl} />
                    )} 
            </Modal>
    </Upload>)
  }
}


// WEBPACK FOOTER //
// ./src/components/Upload/SelectFile.js